import { Box, Skeleton } from "@mui/material";

const SiteSelectorLoader = () => {
  return (
    <Box>
      <Skeleton height="30px" variant="rectangular" animation="wave" />
    </Box>
  );
};

export default SiteSelectorLoader;
